
    import blogSearchQuery from '@/apollo/queries/blog/blogSearch'
    import blogSearchMixin from '~/mixins/blogSearchMixin.js';
    export default {
        name: 'BlogSearchInputContainer',
        mixins: [blogSearchMixin],
    

        props: {
            data: {
                type: Array,
                default: () => [],
            },
            showKeywords: {
                type: Boolean,
                default: false,
            },
        },


        apollo: {
            $loadingKey: "loading",
            keywordData: {
                prefetch: true,
                query: blogSearchQuery,
                variables() {
                return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
                },
                update(data) {
                return this.$normalizeStrapi(data.blogSearchKeywords);
                },
            },
        },


        data() {
        return {
            query: this.$route.query.q,
        };
        },

        methods: {
        },
    }
  